module.exports = __webpack_public_path__ + "assets/business-hour-white.48b808f2.svg";